module.exports = __webpack_public_path__ + "img/public/SiteIcons/g648.svg?b6b5d905";